import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import IAuditoria from "../../../../entities/IAuditoria";
import { IDesviacion } from "../../../../entities/IDesviacion";
import { IEstadoDesviacion } from "../../../../entities/IEstadoDesviacion";
import IGerencia from "../../../../entities/IGerencia";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_ESTADO_AUDITORIA,
  API_ADMIN_GERENCIA,
  API_ADMIN_MANTENEDOR_AUDITORIA,
  API_ADMIN_TIPO_AUDITORIA,
  API_ADMIN_UNIDAD,
  ROW_COUNT,
  URL_SUPPORT,
  API_ADMIN_AUDITORIA,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import { ITipoAuditoria } from "../../../../entities/ITipoAuditoria";
import moment from "moment";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import AuditoriaService from "../../../../services/AuditoriaService";
import VppService from "../../../../services/VppService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActive, cParamsActiveOrderNombre, cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);
interface IMantenedorAuditoriaProps {
  items?: Array<any>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbEstadoDesviacion?: Array<IEstadoDesviacion>;
  cbTipoAuditoria?: Array<ITipoAuditoria>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  is_Test?: boolean;
  openpopUp?: boolean;
}
const RenderButton = (infomau: any, confirm: any) => {
  return (
    <button
      className="btnIcono"
      data-testid={`btndesactivar${infomau.row.original.ID}`}
      title={infomau.row.original.ACTIVO ? "Desactivar" : ""}
      onClick={() => {
        MySwal.fire({
          html: (
            <div>
              <h3>
                ¿Desea {infomau.row.original.ACTIVO ? "desactivar" : "activar"} el registro {infomau.row.original.CORRELATIVO}?
              </h3>
            </div>
          ),
          text: "",
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            MySwal.fire({
              html: (
                <div>
                  <h4>Ingrese un Motivo:</h4>
                </div>
              ),
              input: "textarea",
              inputAttributes: {
                autocapitalize: "off",
              },
              showCancelButton: true,
              confirmButtonText: `<i class="bi bi-eye"></i>${infomau.row.original.ACTIVO ? "Desactivar" : "Activar"}`,
              cancelButtonText: "Cancelar",
              showLoaderOnConfirm: true,
              preConfirm: async (txtMotivo) => {
                await confirm(txtMotivo, infomau.row.original.ACTIVO ?? false, infomau.row.original.CORRELATIVO, infomau.row.original.ID as number);
              },
              allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
              if (result.isConfirmed) {
                console.log(result);
              }
            });
          }
        });
      }}>
      <i className={infomau.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
    </button>
  );
};

const RenderNuevo = (infomau: any) => {
  return (
    <i>
      {infomau.getValue()?.TIPO === ITipo_Campo.user || infomau.getValue()?.TIPO === ITipo_Campo.multiuser
        ? infomau.getValue()[`${infomau.getValue().ID}_DISPLAY`]
        : infomau.getValue()}
    </i>
  );
};

export default function MantenedorAuditoria({
  items,
  openpopUp,
  cbVicepresidencia,
  cbGerenciaSubgerencia,
  cbUnidadProyecto,
  cbEstadoDesviacion,
  cbTipoAuditoria,
  itemsArrCambios,
  is_Test,
}: IMantenedorAuditoriaProps) {
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMAU, setComboVccMAU] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUPMAU, setComboUPMAU] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSGMAU, setComboGSGMAU] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboTAMAU, setComboTAMAU] = useState<Array<ITipoAuditoria>>(cbTipoAuditoria || []);
  const [comboEDMAU, setComboEDMAU] = useState<Array<IEstadoDesviacion>>(cbEstadoDesviacion || []);

  const [isEditColum, setIsEditColumMAU] = useState<boolean>(false);
  const [editColumnInfo, setEditColumnInfoMAU] = useState<any>();
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [filters, setFilters] = useState<any>(null);
  const [showToast, setShowToast] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [arrCambiosFormMAU, setArrCambiosFormMAU] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambiosMAU, setIsOpenPopUpGuardarCambiosMAU] = useState<boolean>(openpopUp ?? false);

  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboVccMAU, setValComboVccMAU] = useState<IComboboxOption | null>(null);
  const [refComboUPMAU, setValComboUPMAU] = useState<IComboboxOption | null>(null);
  const [refComboGSGMAU, setValComboGSGMAU] = useState<IComboboxOption | null>(null);
  const [refComboTAMAU, setValComboTAMAU] = useState<IComboboxOption | null>(null);
  const [refComboEDMAU, setValComboEDMAU] = useState<IComboboxOption | null>(null);
  const [selectedFieldMAU, setSelectedFieldMAU] = useState({} as any);
  const refTxtMotivoMAU = React.createRef<HTMLTextAreaElement>();
  const refTxtAnioMAU = React.createRef<HTMLInputElement>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const columnHelperMantAuditoria = createColumnHelper<IAuditoria>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();
  const [msjErrorForm, setMsjErrorForm] = useState<string[]>([]);
  const [isSendingData, setIsSendingData] = useState(false);
  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedFieldMAU(sf);
  };

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };

  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const confirm = async (txtMotivo: any, activo: boolean, correlativo: string, id: number) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await AuditoriaService.desactivarRegistroAuditoria(token, {
        ID_REGISTRO: id,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "AUDITORIA",
        TABLA: "AUDITORIA",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: correlativo,
      });
      await handleBuscarMAU();
    }
  };
  let columnsDef = [
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `AU."CORRELATIVO"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.ID, {
      id: "DESACTIVAR",
      cell: (infomau: CellContext<IAuditoria, number>) =>
        RenderButton(infomau, (txt: any, activo: any, correlativo: any, id: any) => {
          confirm(txt, activo, correlativo, id);
        }),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IAuditoria, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.ESTADO, {
      id: "ESTADO_AUDITORIA_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Estado"),
      hide: false,
      title: "Estado",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ESTADO"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.ANIO, {
      id: "ANIO_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Año"),
      hide: false,
      title: "Año",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ANIO"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.PROGRAMA, {
      id: "PROGRAMA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Programa"),
      hide: false,
      title: "Programa",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"PROGRAMA"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"VICEPRESIDENCIA"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"GERENCIA_SUBGERENCIA"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"UNIDAD_PROYECTO"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.TIPO_AUDITORIA, {
      id: "TIPO_AUDITORIA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue()),
      header: () => component("Tipo Auditoría"),
      hide: false,
      title: "Tipo Auditoría",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_AUDITORIA"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (infomau: CellContext<IAuditoria, string>) => componentValue(infomau.getValue(), ITipo_Campo.date),
      header: () => component("Fecha Creación"),
      hide: false,
      title: "Fecha Creación",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `AU."FECHA_CREACION"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.FECHA_DESDE, {
      id: "FECHA_DESDE",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(shortDate(infomau.getValue())),
      header: () => component("Fecha Desde"),
      hide: false,
      title: "Fecha Desde",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."FECHA_DESDE"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(shortDate(infomau.getValue())),
      header: () => component("Fecha Hasta"),
      hide: false,
      title: "Fecha Hasta",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."FECHA_HASTA"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.RESPONSABLE_AREA_DISPLAY || rowmau.RESPONSABLE_AREA, {
      id: "RESPONSABLE_AREA",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(infomau.getValue()),
      header: () => component("Responsable Área"),
      hide: false,
      title: "Responsable Área",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."RESPONSABLE_AREA_DISPLAY"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.AUDITOR_LIDER_DISPLAY || rowmau.AUDITOR_LIDER, {
      id: "AUDITOR_LIDER",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(infomau.getValue()),
      header: () => component("Auditor Líder"),
      hide: false,
      title: "Auditor Líder",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."AUDITOR_LIDER_DISPLAY"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.AUDITORES_ACOMPANANTES_DISPLAY || rowmau.AUDITORES_ACOMPANANTES, {
      id: "AUDITORES_ACOMPANANTES",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(infomau.getValue()),
      header: () => component("Auditores Acompañantes"),
      hide: false,
      title: "Auditores Acompañantes",
      tipo: ITipo_Campo.multiuser,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."AUDITORES_ACOMPANANTES_DISPLAY"`,
    } as any),
    columnHelperMantAuditoria.accessor((rowmau) => rowmau.AUTOR_DISPLAY || rowmau.AUTOR, {
      id: "AUTOR",
      cell: (infomau: CellContext<IAuditoria, string>) => componentLink(infomau.getValue()),
      header: () => component("Creado Por"),
      hide: false,
      title: "Creado Por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMAU(cell);
        setIsEditColumMAU(true);
        setIsSendingData(false);
      },
      sortId: `AU."AUTOR_DISPLAY"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboVccMAU = is_Test ? [] : (await VppService.getAll(token, cParamsActiveOrderTitle)).result.data;
    setComboVccMAU(comboVccMAU);
    const comboTAMAU = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre)).result
          .data;
    setComboTAMAU(comboTAMAU);
    let comboEDMAU = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_ESTADO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre)).result
          .data;
    comboEDMAU = comboEDMAU.filter((em: any) => em.ID === 1 || em.ID === 3 || em.ID === 4 || em.ID === 5 || em.ID === 6);
    setComboEDMAU(comboEDMAU);
  }, []);

  const paging = (page: any) => {
    setPage(page);
    filtermau({ PAGINA: page }, true);
  };

  const exportFile = () => {
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMAU?.value;
    const valUP = refComboUPMAU?.value;
    const valGSG = refComboGSGMAU?.value;
    const valED = refComboEDMAU?.value;
    const valAnio = refTxtAnioMAU.current?.value;
    const valTipoAuditoria = refComboTAMAU?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      ESTADO_AUDITORIA: valED,
      CORRELATIVO: valCorr,
      ANIO: valAnio,
      ID_TIPO_AUDITORIA: valTipoAuditoria,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_AUDITORIA}/ExportMantenedorItemNormativa`, { Authorization: `Bearer ${token}` }, params).then((r) => {
      downloadFile(r.result);
    });
  };

  const filtermau = (filtermau: any, page: boolean = false, size = pageSize) => {
    filtermau = updateFilter({ ...filters, ...filtermau }, size, page);
    setPage(filtermau.PAGINA);

    const valCorr = refTxtCorr.current?.value === "Seleccione" ? "" : refTxtCorr.current?.value;
    const valVcc = refComboVccMAU?.value === "Seleccione" ? "" : refComboVccMAU?.value;
    const valUP = refComboUPMAU?.value === "Seleccione" ? "" : refComboUPMAU?.value;
    const valGSG = refComboGSGMAU?.value === "Seleccione" ? "" : refComboGSGMAU?.value;
    const valCSC = refComboTAMAU?.value === "Seleccione" ? "" : refComboTAMAU?.value;
    const valED = refComboEDMAU?.value === "Seleccione" ? "" : refComboEDMAU?.value;
    const valAnio = refTxtAnioMAU.current?.value === "Seleccione" ? "" : refTxtAnioMAU.current?.value;
    const valTipoAuditoria = refComboTAMAU?.value === "Seleccione" ? "" : refComboTAMAU?.value;
    filtermau.UNIDAD_PROYECTO = valUP;
    filtermau.GERENCIA_SUBGERENCIA = valGSG;
    filtermau.VICEPRESIDENCIA = valVcc;
    filtermau.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filtermau.ESTADO = valED;
    filtermau.CORRELATIVO = valCorr;
    filtermau.ANIO = valAnio;
    filtermau.ID_TIPO_AUDITORIA = valTipoAuditoria;

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_AUDITORIA}/`, { Authorization: `Bearer ${token}` }, filtermau)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editmau = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID == "") {
      delete value.ID;
    }
  };

  const validateNotSameUsers = (columnId: string, originalRow: any): boolean => {
    let txtError = [];
    let isInvalid = false;
    let flag = true;
    console.log("columnId", columnId);
    console.log("originalRow", originalRow);
    if (
      columnId === "RESPONSABLE_AREA" &&
      (originalRow.AUDITOR_LIDER === selectedFieldMAU.RESPONSABLE_AREA ||
        esAuditorParticipante(originalRow.AUDITORES_ACOMPANANTES, selectedFieldMAU.RESPONSABLE_AREA))
    ) {
      isInvalid = true;
      txtError.push("Auditor Líder o Auditores Acompañantes, no pueden ser Responsable Área");
    }
    if (
      columnId === "AUDITOR_LIDER" &&
      (originalRow.RESPONSABLE_AREA === selectedFieldMAU.AUDITOR_LIDER ||
        esAuditorParticipante(originalRow.AUDITORES_ACOMPANANTES, selectedFieldMAU.AUDITOR_LIDER))
    ) {
      isInvalid = true;
      txtError.push("Responsable Área o Auditores Acompañantes, no pueden ser Auditor Líder");
    }
    if (
      columnId === "AUDITORES_ACOMPANANTES" &&
      (esAuditorParticipante(selectedFieldMAU.AUDITORES_ACOMPANANTES, originalRow.AUDITOR_LIDER) ||
        esAuditorParticipante(selectedFieldMAU.AUDITORES_ACOMPANANTES, originalRow.RESPONSABLE_AREA))
    ) {
      isInvalid = true;
      txtError.push("Responsable Área o Auditor Líder, no pueden ser Auditores Acompañantes");
    }
    if (isInvalid) {
      flag = false;
      setMsjErrorForm(txtError);
    }

    return flag;
  };
  const handleBuscarMAU = async () => {
    setIsLoading(true);
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMAU?.value === "Seleccione" ? "" : refComboVccMAU?.value;
    const valUP = refComboUPMAU?.value === "Seleccione" ? "" : refComboUPMAU?.value;
    const valGSG = refComboGSGMAU?.value === "Seleccione" ? "" : refComboGSGMAU?.value;
    const valED = refComboEDMAU?.value === "Seleccione" ? "" : refComboEDMAU?.value;
    const valAnio = refTxtAnioMAU.current?.value;
    const valTipoAuditoria = refComboTAMAU?.value === "Seleccione" ? "" : refComboTAMAU?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      ESTADO_AUDITORIA: valED,
      CORRELATIVO: valCorr,
      ANIO: valAnio,
      ID_TIPO_AUDITORIA: valTipoAuditoria,
    };
    setFilters(params);
    const result = is_Test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_AUDITORIA}/`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    setHideTable(false);
    setIsLoading(false);
  };

  const confirmed2 = async () => {
    let arrDesviaciones: Array<IDesviacion> = is_Test ? items ?? [] : [];
    let arrLogs: Array<ILogMantenedor> = [];

    arrCambiosFormMAU.forEach((ac) => {
      if (!arrDesviaciones.find((d) => d.ID === ac.ID)) {
        arrDesviaciones.push(ac.OBJETO_REF);
      }
    });

    arrDesviaciones.forEach((d: any) => {
      arrCambiosFormMAU
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "AUDITORIA",
            TABLA: "AUDITORIA",
            ID_REGISTRO: Number(d.ID),
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivoMAU.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.CORRELATIVO,
          };

          if (ac.TIPO === ITipo_Campo.user || ac.TIPO === ITipo_Campo.multiuser) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else if (ac.TIPO === ITipo_Campo.date) {
            d[ac.CAMPO_EDITADO_ID] = moment(ac.VALOR_NUEVO).toDate();
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      AUDITORIAS: arrDesviaciones,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_AUDITORIA}/`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        let params = { PAGINA: page };
        filtermau(params);
        if (refTxtMotivoMAU.current) {
          refTxtMotivoMAU.current.value = "";
        }
        setArrCambiosFormMAU([]);
        setIsOpenPopUpGuardarCambiosMAU(false);
        setShowToast(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const esAuditorParticipante = (users: string | undefined, emailUser: string) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  return (
    <section>
      <div className="row">
        <button
          hidden={true}
          data-testid="btnbuscarmau"
          onClick={() => {
            handleBuscarMAU();
          }}></button>
        <button
          hidden={true}
          data-testid="btneditmau"
          onClick={() => {
            editmau({ AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID: "" }, {});
          }}></button>
        <button
          hidden={true}
          data-testid="btnexport"
          onClick={() => {
            exportFile();
          }}></button>
        <button
          hidden={true}
          data-testid="btnconfirmar"
          onClick={() => {
            if (itemsArrCambios !== undefined) {
              confirm("ss", true, "", 1);
            }
          }}></button>
        <button
          hidden={true}
          data-testid="btnconfirmar2"
          onClick={() => {
            paging(1);
            confirmed2();
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Auditoría</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </Col>
                <Col xs="12" md="6" lg="6">
                  <Col>
                    <label>Búsqueda por Año:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtAnioMAU} className="form-control form-control-sm" />
                  </Col>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={comboVccMAU.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVccMAU || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMAU(e);
                      let paramsActive = {
                        ...cParamsActiveOrderTitle,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSGMAU = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSGMAU([]);
                        setComboGSGMAU(comboGSGMAU);
                        setComboUPMAU([]);
                      } else {
                        setComboGSGMAU([]);
                        setComboUPMAU([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSGMAU || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSGMAU.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSGMAU(e);
                      let paramsActive = {
                        ...cParamsActive,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUPMAU = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;
                        setComboUPMAU(comboUPMAU);
                      } else {
                        setComboUPMAU([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUPMAU || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUPMAU.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUPMAU(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Tipo Auditoría:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboTAMAU || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboTAMAU.map((vcc) => ({ value: vcc.ID?.toString() || "", label: vcc.NOMBRE }))}
                    onChange={async (e: any) => {
                      setValComboTAMAU(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Estado Auditoría:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboEDMAU || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEDMAU.map((vcc) => ({ value: vcc.NOMBRE, label: vcc.NOMBRE }))}
                    onChange={async (e: any) => {
                      setValComboEDMAU(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    data-testid="btnbuscar"
                    onClick={async () => {
                      await handleBuscarMAU();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    data-testid="btnlimpiar"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      (refTxtAnioMAU.current as HTMLInputElement).value = "";
                      setValComboVccMAU(null);
                      setValComboUPMAU(null);
                      setValComboGSGMAU(null);
                      setValComboTAMAU(null);
                      setValComboEDMAU(null);
                      setArrCambiosFormMAU([]);
                      setListItems([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>
                  {arrCambiosFormMAU.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMAU(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filtermau}
          items={[]}
          callback={editmau}
          data={listItems}
          tipo={"MantenedorDesviaciones"}
          filter={filtermau}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          columnsDef={columnsDef}
          hideExport={true}
          exportar={exportFile}
          hideAdd={true}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filtermau(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setMsjErrorForm([]);
            setIsEditColumMAU(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              {editColumnInfo?.column.columnDef.tipo === ITipo_Campo.date ? (
                <div>{editColumnInfo && moment(editColumnInfo?.getValue()).format("DD/MM/yyyy")}</div>
              ) : (
                <div>{editColumnInfo && editColumnInfo?.getValue()}</div>
              )}
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
              </div>
              <form>
                {
                  <RenderForm
                    id={editColumnInfo?.column?.id}
                    tipoCampo={editColumnInfo?.column.columnDef.tipo}
                    valor={""}
                    texto={""}
                    callback={changeField}
                  />
                }
              </form>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    // NOSONAR Dejamos justificado que necesitamos estas validaciones ya que son necesarias para validar campos obligatorios del mantenedor de auditoría
                    let json = selectedFieldMAU;
                    const columnId = editColumnInfo.column.columnDef.id;
                    const originalRow = editColumnInfo.row.original;
                    let arr = arrCambiosFormMAU;
                    json = {
                      ID: editColumnInfo.row.original.ID,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: columnId,
                      VALOR_ORIGINAL:
                        editColumnInfo?.column.columnDef.tipo === ITipo_Campo.date
                          ? moment(editColumnInfo?.getValue()).format("yyyy-MM-DD")
                          : editColumnInfo?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.user || editColumnInfo.column.columnDef.tipo === ITipo_Campo.multiuser
                          ? selectedFieldMAU
                          : selectedFieldMAU[editColumnInfo.column.columnDef.id],
                      OBJETO_REF: originalRow,
                      TIPO: editColumnInfo.column.columnDef.tipo,
                    };
                    let notSameUserTable = false;
                    let notSameUserForm = false;
                    let isSameUserForm = false;
                    arrCambiosFormMAU.forEach((cambioForm) => {
                      if (cambioForm.ID === json.ID && !isSameUserForm) {
                        let NotSameUser = validateNotSameUsers(json.CAMPO_EDITADO_ID, cambioForm.VALOR_NUEVO);
                        if (!NotSameUser) isSameUserForm = true;
                      }
                    });
                    if (!isSameUserForm) notSameUserForm = true;

                    notSameUserTable = validateNotSameUsers(columnId, originalRow);
                    if (
                      notSameUserTable &&
                      notSameUserForm &&
                      !isSendingData &&
                      json.VALOR_ORIGINAL !==
                        (editColumnInfo.column.columnDef.tipo === ITipo_Campo.user || editColumnInfo.column.columnDef.tipo === ITipo_Campo.multiuser
                          ? json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                          : json.VALOR_NUEVO)
                    ) {
                      arr.push(json);
                      setArrCambiosFormMAU(arr);
                      setIsEditColumMAU(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMAU(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
              {msjErrorForm.length > 0 && <span className="error mt-2">{msjErrorForm.concat("\n")}</span>}
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambiosMAU && (
        <Offcanvas
          show={isOpenPopUpGuardarCambiosMAU}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMAU(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Auditoría:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filtermau}
                items={[]}
                callback={editmau}
                data={arrCambiosFormMAU}
                tipo="MantenedorDesviaciones"
                filter={filtermau}
                pagination={{ pages: pages, page: page, paging: paging }}
                title=""
                hideExport={true}
                hideAdd={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowmau) => rowmau.ID, {
                    id: "ID",
                    cell: (infomau: CellContext<IConfirmacionMantenedor, string>) => componentValue(infomau.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmau) => rowmau.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (infomau: CellContext<IConfirmacionMantenedor, string>) => componentValue(infomau.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmau) => rowmau.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (infomau: CellContext<IConfirmacionMantenedor, string>) =>
                      componentValue(
                        infomau.getValue(),
                        moment(infomau.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text
                      ),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmau) => rowmau.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (infomau: CellContext<IConfirmacionMantenedor, any>) =>
                      componentValue(
                        infomau.getValue(),
                        moment(infomau.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : infomau.getValue()?.TIPO
                      ),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivoMAU} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  data-testid="btnaceptar"
                  onClick={() => {
                    if (!refTxtMotivoMAU.current?.value) {
                      refTxtMotivoMAU.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivoMAU.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivoMAU.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then(async (result: any) => {
                      if (result.isConfirmed) {
                        await confirmed2();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMAU(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
